<div
  class="overlay overlay-{{ style }}"
  (click)="onOverlayClicked(true)"
  [@modalAnimation]
>
  <div
    class="modal-wrapper modal-{{ size }}"
    (click)="onDialogClicked($event)"
    [ngClass]="{ 'modal-scroll': scroll }"
  >
    <div class="modal">
      <!-- *ngIf="closeButton" class="icon" -->
      <ark-icon
        icon="system-close"
        *ngIf="closeButton"
        class="icon"
        size="small"
        (click)="onOverlayClicked()"
      ></ark-icon>
      <ng-template arkModalInsertion> </ng-template>
    </div>
  </div>
</div>
